import { useState } from "react";
import { useSeo } from "@/hooks/useSeo";
import { news } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";
import Breadcrumbs from "@/components/feature/Breadcrumbs";

const PAGE_SIZE = 6;

export default function NewsList() {
  useSeo({
    title: "希岛爱理影视资讯 - 最新动态与专题报道",
    description:
      "汇总希岛爱理相关的最新影视动态、作品上映消息、预告发布与专题报道，及时了解影视圈内的相关资讯。",
    keywords: "希岛爱理资讯,影视动态,影视新闻,作品上映,专题报道",
  });

  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(news.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const paged = news.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="w-full pb-16">
      <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "资讯" }]} />

      <div className="w-full px-4 md:px-8 pt-6">
        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10">
          <span className="text-xs font-label font-semibold tracking-[0.2em] uppercase text-accent-600">
            News & Updates
          </span>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
            影视资讯
          </h1>
          <p className="text-sm text-foreground-600 mt-3 max-w-3xl leading-relaxed">
            关注希岛爱理的影视动态：作品上映、预告释出、评选提名与专题回顾，都在这里集中呈现。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 pt-8">
        {paged.length > 0 ? (
          <div className="flex flex-col gap-4">
            {paged.map((item) => (
              <NewsCard key={item.id} item={item} layout="row" />
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 py-20 text-center">
            <i className="ri-newspaper-line text-4xl text-foreground-300" />
            <p className="mt-3 text-foreground-700">暂无最新资讯</p>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="w-full px-4 md:px-8 pt-10 flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            <i className="ri-arrow-left-s-line" />
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => setPage(n)}
              className={`min-w-9 h-9 px-3 rounded-md text-sm transition-colors cursor-pointer ${
                n === currentPage
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 text-foreground-700 hover:border-primary-300"
              }`}
            >
              {n}
            </button>
          ))}
          <button
            type="button"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            <i className="ri-arrow-right-s-line" />
          </button>
        </div>
      )}
    </div>
  );
}